import axios from "axios";
import { getRToken, getToken, getUrl, logout } from "../utils/app.utils";


const token = getToken();
const rToken = getRToken();

export const fileUrl = process.env.REACT_APP_IMAGE_URL;
const instance = axios.create({
  baseURL: process.env.REACT_APP_BASE_API,
  timeout: 100000,
  headers: {
    "Content-Type": "application/json",
    Authorization: token ? `Bearer ${token}` : "",
  },
});

instance.interceptors.request.use(
  function (config) {
    return config;
  },
  function (error) {
    console.log(error);
  }
);

if (token) {
  instance.interceptors.response.use(
    (resp: any) => {
      return resp;
    },
    (validate) => {
      if (validate?.response?.status === 401) {
        const getRefreshToken = async () => {
          try {
            const url = await getUrl()
            const res = await axios.post(
              url.REACT_APP_BASE_API + "/auth/refresh", { refreshToken: localStorage.getItem("RTOKEN") },
              {
                headers: {
                  Authorization: "Bearer " + token,
                },
              }
            );
            const data: any = await res.data;
            localStorage.setItem("TOKEN", data.result.accessToken);
            localStorage.setItem("RTOKEN", data.result.refreshToken);
            window.location.reload()


          } catch {
            logout()
            window.location.href = '/login'
          }
        };

        getRefreshToken();
      }
      return validate;
    },

  );
}
export default class BaseAPI {
  static api = instance;
}

export function setDefaultURL(url: any) {

  instance.defaults.baseURL = url;

}



